import React from 'react';
import PropTypes from 'prop-types';
import FlexGroup from 'components/FlexGroup';
import CustomMainTypeFilter from 'components/Ticket/MainType';
import CustomSubTypeFilter from 'components/Ticket/SubType';
import CustomStatusFilter from './Status';
import CustomPriorityFilter from './Priority';
import CustomAssigneeFilter from './Assignee';
import CustomTicketFlowFilter from './TicketFlow';
import CustomCreatedTimeFilter from './CreatedTime';
import VipScooterFilter from 'components/Filter/VipScooterFilter';

export const FILTER_KEYWORD = 'keyword';
export const FILTER_KEYWORD_TYPE = 'keyword_type';
export const FILTER_TICKET_MAIN_TYPE = 'tracker_id';
export const FILTER_TICKET_SUB_TYPE = 'tracker_subtype_id';
export const FILTER_STATUS = 'status_id';
export const FILTER_PRIORITY = 'severity_id';
export const FILTER_ASSIGNEE = 'assigned_to_id';
export const FILTER_TICKET_FLOW = 'franchisee_author_assignee';
export const FILTER_CREATE_TIME = 'create_time';
export const FILTER_VIP_SCOOTER = 'service_id';


const TicketFilter = ({
    filters,
    excludeList,
    onChange,
    isForcedOpen,
    disabled,
}) => {
    return (
        <>
            <FlexGroup start className="filters">
                {
                    excludeList.length && excludeList.includes(FILTER_TICKET_MAIN_TYPE) ? null : (
                        <CustomMainTypeFilter
                            selected={ filters[FILTER_TICKET_MAIN_TYPE] }
                            onChange={ onChange(FILTER_TICKET_MAIN_TYPE) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_TICKET_SUB_TYPE) ? null : (
                        <CustomSubTypeFilter
                            selected={ filters[FILTER_TICKET_SUB_TYPE] }
                            onChange={ onChange(FILTER_TICKET_SUB_TYPE) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_STATUS) ? null : (
                        <CustomStatusFilter
                            selected={ filters[FILTER_STATUS] }
                            onChange={ onChange(FILTER_STATUS) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_PRIORITY) ? null : (
                        <CustomPriorityFilter
                            selected={ filters[FILTER_PRIORITY] }
                            onChange={ onChange(FILTER_PRIORITY) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_CREATE_TIME) ? null : (
                        <CustomCreatedTimeFilter
                            onChange={ onChange(FILTER_CREATE_TIME) }
                            defaultFrom={ filters.create_from }
                            defaultTo={ filters.create_to }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_ASSIGNEE) ? null : (
                        <CustomAssigneeFilter
                            selected={ filters[FILTER_ASSIGNEE] }
                            onChange={ onChange(FILTER_ASSIGNEE) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_TICKET_FLOW) ? null : (
                        <CustomTicketFlowFilter
                            selected={ filters[FILTER_TICKET_FLOW] }
                            onChange={ onChange(FILTER_TICKET_FLOW) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FILTER_TICKET_MAIN_TYPE) ? null : (
                        <VipScooterFilter
                            defaultSelected={ filters[FILTER_VIP_SCOOTER] }
                            onChange={ onChange(FILTER_VIP_SCOOTER) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
            </FlexGroup>
        </>
    );
};
TicketFilter.propTypes = {
    filters: PropTypes.shape({}),
    excludeList: PropTypes.arrayOf(PropTypes.oneOf([
        FILTER_TICKET_MAIN_TYPE,
        FILTER_TICKET_SUB_TYPE,
        FILTER_STATUS,
        FILTER_PRIORITY,
        FILTER_ASSIGNEE,
        FILTER_TICKET_FLOW,
        FILTER_CREATE_TIME,
        FILTER_VIP_SCOOTER,
    ])),
    onChange: PropTypes.func.isRequired,
    isForcedOpen: PropTypes.bool,
};
TicketFilter.defaultProps = {
    filters: {},
    excludeList: [],
    isForcedOpen: false,
};
export default TicketFilter;
